var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('h1',[_vm._v("Adrian Rodriguez Mejia")]),_c('h2',[_vm._v("CRUD Factura Tech")]),_c('CrudUsers'),_c('footer',[_c('ExercisesTest')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }